import React from "react";
import styled from "@emotion/styled";
import {useViewController} from "data/services/locator";
import {ILocalizationController} from "views/controllers/localization/localization.controller";
import {Bindings} from "data/constants/bindings";
import {IMatch} from "data/types/entities";

const Wrapper = styled.div`
	display: flex;
	flex-flow: column;
	height: 100%;
	padding: 12px 20px;
	background: var(--primaryColor2);
`;

const Title = styled.h6`
	color: #fff;
	text-align: center;
	font-family: var(--fontFamilySecond);
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 100%; /* 18px */
	letter-spacing: 0.2px;
	text-transform: uppercase;
`;

const Description = styled.p`
	color: #fff;
	text-align: center;
	font-family: var(--fontFamilyBase);
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 125%; /* 15px */
	letter-spacing: 0.24px;
`;

interface IProps {
	match: IMatch;
}
export const MatchHidden: React.FC<IProps> = ({match}) => {
	const {i18n} = useViewController<ILocalizationController>(Bindings.LocalizationController);

	return (
		<Wrapper>
			<Title>{i18n.t("match_hidden.title", "Please note")}</Title>
			<Description>
				{i18n.t(
					"match_hidden.description",
					`CFL Statistics is currently experiencing a minor technical issue. We appreciate your continued patience as we rectify the situation`,
					{
						home: match.homeSquad.shortName,
						away: match.awaySquad.shortName,
					}
				)}
			</Description>
		</Wrapper>
	);
};
